export type SessionBootstrapCoordinator<TResult> = {
  run: (load: () => Promise<TResult>) => Promise<TResult>;
};

/**
 * Creates a small coordinator that shares only the currently pending bootstrap.
 * React Strict Mode can start the same initialization effect twice; both callers
 * receive one result, while a later genuine App mount can start a fresh load.
 */
export function createSessionBootstrapCoordinator<TResult>(): SessionBootstrapCoordinator<TResult> {
  let inFlight: Promise<TResult> | null = null;

  return {
    run(load) {
      if (inFlight) {
        return inFlight;
      }

      const pending = load();
      inFlight = pending;
      void pending.then(
        () => {
          if (inFlight === pending) {
            inFlight = null;
          }
        },
        () => {
          if (inFlight === pending) {
            inFlight = null;
          }
        },
      );
      return pending;
    },
  };
}
